import { render, staticRenderFns } from "./yhzx.vue?vue&type=template&id=374976c9&scoped=true"
import script from "./yhzx.vue?vue&type=script&lang=js"
export * from "./yhzx.vue?vue&type=script&lang=js"
import style0 from "./yhzx.vue?vue&type=style&index=0&id=374976c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374976c9",
  null
  
)

export default component.exports